<template>
  <button
    class="btn--sync btn-success"
    v-show="show"
    v-on:click="$emit('handleSync')"
  >
    <i
      class="fa fa-wrapper fa-sync-alt normal-icon"
      style="vertical-align: middle"
      aria-hidden="true"
    ></i>
    <span class="u-hide-mobile">&nbsp;Sync</span>
  </button>
</template>
<style>
.btn--sync {
  position: fixed;
  right: 5%;
  top: 9rem;
}

@media only screen and (max-width: 1023px) {
  .btn--sync {
    right: 1rem;
  }
}
</style>
<script>
export default {
  name: "sync-button",
  props: {
    show: Boolean
  },
  computed: {
    key: function() {
      let val = this.$route.path;
      val = val.startsWith("/") ? val.slice(1) : val;
      val = val.endsWith("/") ? val : val + "/";
      return val;
    }
  }
};
</script>
